import { render, staticRenderFns } from "./IntegrationsModal.vue?vue&type=template&id=b428ae14"
import script from "./IntegrationsModal.vue?vue&type=script&lang=js"
export * from "./IntegrationsModal.vue?vue&type=script&lang=js"
import style0 from "./IntegrationsModal.vue?vue&type=style&index=0&id=b428ae14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports